import { reduceResolution, wbp } from 'Theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSearchClientStyles = makeStyles((theme: Theme) =>
    createStyles({
        boxItem: {
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(5)}px 0`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '5px 0'
            },
            '&:hover': { background: '#eee' }
        },
        field: {
            'fontSize': 16,
            'width': '100%',

            '&.makeStyles-field-156 .MuiInputBase-root': {
                height: '54px',
                borderRadius: '33px',
                paddingLeft: '20px'
            },
            '&.makeStyles-field-156 input': {
                height: '54px',
                fontSize: '16px'
            },
            '& .MuiInputBase-input': {
                paddingLeft: 35,
                paddingRight: 16
            },

            [theme.breakpoints.up('md')]: {
                width: '406px'
            }
        },
        fieldSearch: {
            'border': '0 !important',

            '& .MuiOutlinedInput-root': {
                border: '10px !important',
                borderRadius: '30px 30px 0 0'
            }
        },
        wrapperResult: {
            width: '100%',
            position: 'relative'
        },
        boxResult: {
            width: '100%',
            cursor: 'default',
            position: 'absolute',
            backgroundColor: '#fff',
            borderLeft: '1px solid #eee',
            borderRight: '1px solid #eee',
            borderBottom: '1px solid #eee',
            borderRadius: '0 0 20px 20px',
            padding: '8px 10px 10px 10px',

            [theme.breakpoints.up('md')]: {
                width: '406px'
            }
        },

        boxTitle: {
            paddingBottom: 16,

            [theme.breakpoints.up('md')]: {
                paddingBottom: 10
            }
        },

        parentTitle: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 600
        },
        chipParent: {
            'height': 54,
            'fontSize': 16,
            'width': '100%',
            'background': '#fff',
            'border': '1px solid #222',
            'paddingLeft': 35,
            'paddingRight': 16,

            [theme.breakpoints.up('md')]: {
                padding: '10px 10px'
            },

            '& .MuiChip-deleteIcon': {
                margin: 0
            },
            '&.MuiChip-root': {
                borderRadius: '33px !important',
                justifyContent: 'space-between !important',
                paddingLeft: '25px !important',

                [theme.breakpoints.up('md')]: {
                    margin: '40px 0 28px 0!important'
                }
            },
            '& .MuiChip-label': {
                padding: 0
            }
        },

        clientLink: {
            'cursor': 'pointer',
            'textDecoration': 'none',
            'color': '#000',
            'width': '180px',
            'alignItems': 'center',
            '&:hover': {
                color: '#EAB464'
            }
        },

        addNewButton: {
            marginTop: 16,

            [theme.breakpoints.up(wbp)]: {
                marginTop: '5px',
                padding: '14px 16px'
            }
        },
        listAlignedIcons: {
            width: '16px !important'
        },
        parentReadOnly: {
            fontWeight: 600,
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(20)}px ${reduceResolution(0)}px`,
                fontSize: `${reduceResolution(16)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '20px 0',
                fontSize: '16px'
            }
        },
        sectionIcon: {
            marginRight: '0.5rem'
        },

        boxLoading: {
            textAlign: 'center'
        },

        loading: {
            color: '#AAA'
        },

        desktop: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        mobile: {
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        }
    })
);
